import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16 text-center">
      <h1 className="text-2xl font-semibold text-neutral-900">404 — Page not found</h1>
      <Link to="/" className="mt-4 inline-block text-sm text-neutral-600 underline">
        Back to Home
      </Link>
    </div>
  );
}
